import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ActivityGroup.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ActivityGroup.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const ACTIVITYGROUP_CONFIG = {
  entityName: 'ActivityGroup',
  localizationKey: 'Controlling::Entity.ActivityGroup',
  fields: ACTIVITYGROUP_FIELDS,
  permission: 'ControllingActivities.ActivityGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
